import React from 'react';
import paymentStatus from '../../../constants/paymentStatusConstants.js';
import { containerStyle, fieldsetStyle, radioLabel } from '../styles.js';
var StubbedStatusSelector = function StubbedStatusSelector(_ref) {
  var stubbedStatus = _ref.stubbedStatus,
    _onChange = _ref.onChange;
  return React.createElement("div", {
    style: containerStyle
  }, React.createElement("fieldset", {
    style: fieldsetStyle
  }, React.createElement("legend", null, "Stubbed status options:"), Object.values(paymentStatus).map(function (status) {
    return React.createElement("label", {
      key: status,
      style: radioLabel
    }, React.createElement("input", {
      type: "radio",
      name: "stubbedStatus",
      value: status,
      checked: stubbedStatus === status,
      onChange: function onChange() {
        return _onChange(status);
      }
    }), status);
  })));
};
export { StubbedStatusSelector as default };